<script>
export default {
  props: {
    statuses: { type: Array, default: () => [] },
  },
  methods: {
    dotColor(status) {
      const map = {
        aprovado:  '#34C392',
        assinado:  '#34C392',
        enviado:   '#50a5f1',
        reprovado: '#EB1C24',
        pendente:  '#d1d1e3',
        aguardando:'#f1b44c',
      }
      return map[status] || '#d1d1e3'
    },
  },
}
</script>

<template>
  <div class="d-flex align-items-center" style="gap: 4px;">
    <span
      v-for="(s, i) in statuses"
      :key="i"
      :title="s"
      :style="{
        backgroundColor: dotColor(s),
        width: '22px',
        height: '6px',
        borderRadius: '999px',
        display: 'inline-block',
      }"
    ></span>
  </div>
</template>
